import { FrameLoop } from '@/types';
import { create } from 'zustand';

interface FrameLoopState {
  frameLoop: FrameLoop;
  setFrameLoop: (frameLoop: FrameLoop) => void;
}

export const useEventSourceStore = create<FrameLoopState>((set) => {
  return {
    frameLoop: 'always',
    setFrameLoop: (v) => set({ frameLoop: v }),
  };
});

export default useEventSourceStore;
